import { css } from 'linaria';
import { styled } from 'linaria/react';
import { CardGrid, LinkWithGAClickButton } from 'common/components';

export const assortmentSection = css`
  position: relative;
`;

export const descriptionStyle = css`
  max-width: 760px;
  margin: 0 0 32px;

  @media (--only-desktop) {
    max-width: 740px;
    margin-bottom: 40px;
  }

  @media (--to-desktop) {
    max-width: 100%;
    margin-bottom: 24px;
  }
`;

export const StyledCardGrid = styled(CardGrid)`
  display: grid;
  justify-content: space-between;
  grid-template-columns: repeat(5, 217px);
  grid-template-rows: 358px;

  @media (--only-desktop) {
    grid-template-columns: repeat(3, 31.06%);
    grid-template-rows: 315px 315px;
    row-gap: 48px;
  }

  @media (--only-tablet) {
    grid-template-columns: repeat(2, 48.18%);
    grid-template-rows: repeat(3, 311px);
    row-gap: 32px;
  }

  @media (--only-mobile) {
    grid-template-columns: 100%;
    grid-template-rows: repeat(5, 280px);
    row-gap: 24px;
  }
`;

export const cardMediaStyle = css`
  height: 248px;

  @media (--only-desktop) {
    height: 205px;
  }

  @media (--only-tablet) {
    height: 223px;
  }

  @media (--only-mobile) {
    height: 202px;
  }
`;

export const DownloadCatalog = styled(LinkWithGAClickButton)`
  position: absolute;
  top: 80px;
  right: 0;
  display: flex;
  align-items: center;

@media (--from-tablet) and (--to-largeDesktop) {    top: auto;
    bottom: 0;
  }

  @media (--only-mobile) {
    position: static;
    margin-top: 24px;
  }
`;

export const DownloadCatalogContent = styled.div`
  @media (--only-mobile) {
    order: 2;
  }
`;

export const downloadCatalogTitleStyle = css`
  display: block;
  margin-bottom: 6px;

  @media (--to-desktop) {
    max-width: 134px;
  }

  @media (--only-mobile) {
    max-width: 100%;
  }
`;

export const downloadCatalogSizeStyle = css`
  display: block;
  font-weight: 500;
`;

export const DownloadCatalogImage = styled.img`
  width: 67px;
  height: 96px;
  margin-left: 24px;

  @media (--to-desktop) {
    margin-left: 16px;
  }

  @media (--only-mobile) {
    margin-right: 20px;
    margin-left: 0;
  }
`;
